import React from "react";
import { Image } from "semantic-ui-react";

function Loader() {
  return <Image src="/images/loader.gif" centered />;
}
export default Loader;
